import dynamic from 'next/dynamic'

export const FullWidthVideo = dynamic(() => import('./full-width-video'))
